import client, { mock, isRealApiEnabled } from "./client";
import tagsMock from "./mocks/tags";

/**
 * @endpoint GET /api/v1/tags
 * @returns {Promise<Tag[]>}
 */
export function list() {
  if (isRealApiEnabled()) return client.get("/v1/tags");
  return mock(tagsMock);
}

/**
 * @endpoint POST /api/v1/tags
 * @returns {Promise<Tag>}
 */
export function create(payload) {
  if (isRealApiEnabled()) return client.post("/v1/tags", payload);
  const created = {
    id: `tag_new_${Date.now()}`,
    name: (payload && payload.name) || "new-tag",
    type: (payload && payload.type) || "keyword",
    productCount: 0,
  };
  tagsMock.push(created);
  return mock(created);
}

/**
 * @endpoint DELETE /api/v1/tags/:id
 * @returns {Promise<{id: string, deleted: true}>}
 */
function deleteTag(id) {
  if (isRealApiEnabled())
    return client.del(`/v1/tags/${encodeURIComponent(id)}`);
  const idx = tagsMock.findIndex((t) => t.id === id);
  if (idx !== -1) tagsMock.splice(idx, 1);
  return mock({ id, deleted: true });
}

export { deleteTag as delete };
